// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    HTML_SITEMAP_POST_LOADING() {
      return {
        isLoading: true,
        htmlSitemapPost: action.htmlSitemapPost
      };
    },
    HTML_SITEMAP_POST_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const htmlSitemapPostQuery = get(
        currentState,
        'htmlSitemapPost.data.query.queryString'
      );
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        htmlSitemapPostQuery,
        'htmlSitemapPost'
      );

      return {
        isLoading: false,
        data: action.htmlSitemapPost,
        ads: adModelData
      };
    },
    HTML_SITEMAP_POST_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.htmlSitemapPost.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
